import React from 'react';
import styled from 'styled-components';
import {
  screenMdMin,
  spacer,
  desktopFinaleBold,
  desktopMestoBold,
  cssColorValue,
} from '@spotify-internal/encore-web-v6';
import { useT } from '@spotify-internal/i18n-core';
import { TRACK_CAT } from '../constants';

import { Link } from '../../../ui';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacer.spacer16};

  @media (min-width: ${screenMdMin}) {
    gap: ${spacer.spacer32};
  }
`;

export const PolicyLink = styled(Link)`
  opacity: 75%;
  text-decoration: none;
  ${() => desktopFinaleBold}
  @media (min-width: ${screenMdMin}) {
    ${() => desktopMestoBold}
  }
  &:hover {
    color: ${cssColorValue('textBase')} !important;
    text-decoration: none !important;
    opacity: 100% !important;
  }
`;

export function Policies() {
  const t = useT();

  const links = [
    {
      label: t(
        'FRODOR_LEGAL_LINK_TEXT_FOOTER',
        'Legal',
        'Legal refers to terms and conditions',
      ),
      href: 'https://www.spotify.com/legal/spotify-for-artists-terms-and-conditions/',
      dataTestId: 'footer-legal',
      track: 'Legal',
    },
    {
      label: t(
        'FRODOR_PRIVACY_LINK_TEXT_FOOTER',
        'Privacy',
        'Refers to the privacy policy',
      ),
      href: 'https://www.spotify.com/legal/privacy-policy/',
      dataTestId: 'footer-privacy',
      track: 'Privacy Policy',
    },
    {
      label: t(
        'FRODOR_COOKIES_LINK_TEXT_FOOTER',
        'Cookies',
        'Cookies are a user tracking method for the web',
      ),
      href: 'https://www.spotify.com/legal/cookies-policy/',
      dataTestId: 'footer-cookies',
      track: 'Cookies',
    },
  ].map(link => {
    return (
      <PolicyLink
        key={link.label}
        href={link.href}
        data-testid={link.dataTestId}
        aria-label={link.label}
        track={[TRACK_CAT, link.track]}
        external
      >
        {link.label}
      </PolicyLink>
    );
  });

  return <Container>{links}</Container>;
}
